import { Link } from 'react-router-dom';
import { latestComics } from '@/mocks/comics';

export default function LatestSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-3">
            <div>
              <span className="text-xs text-foreground-400 tracking-wider uppercase">持续更新</span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2">
                最新更新漫画
              </h2>
            </div>
            <Link to="/category/comedy" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1">
              更多更新
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
            {latestComics.map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.slug}`}
                className="group relative rounded-lg overflow-hidden cursor-pointer flex flex-col bg-background-100 hover:bg-background-200/70 transition-colors"
              >
                <div className="relative aspect-[5/7] overflow-hidden">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <span className="absolute bottom-3 left-3 text-white text-xs bg-accent-500/90 px-2 py-0.5 rounded whitespace-nowrap">
                    更新于 {comic.updateTime}
                  </span>
                </div>
                <div className="p-4 flex flex-col gap-2 flex-1">
                  <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                    {comic.description}
                  </p>
                  <div className="flex flex-wrap items-center gap-1.5 mt-auto pt-2">
                    {comic.tags.slice(0, 3).map((tag) => (
                      <span key={tag} className="text-[10px] text-secondary-700 bg-secondary-100/80 px-2 py-0.5 rounded-full whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}